import { DefaultMantineColor, InputWrapper, InputWrapperProps, Text } from "@mantine/core"

type ReadOnlyInputProps = Omit<InputWrapperProps, "children" | "defaultValue" | `on${string}`> & {
  value?: string | null
  adminLabel?: string
  color?: DefaultMantineColor
  error?: boolean
}

export const ReadOnlyInput = ({
  value,
  adminLabel,
  color,
  error,
  ...props
}: ReadOnlyInputProps) => {
  return (
    <InputWrapper
      {...props}
      label={adminLabel || props.placeholder || props.label}
      description={null}
      required={false}
      styles={(theme) => ({
        label: {
          color: error ? theme.colors.red[theme.colorScheme === "dark" ? 6 : 7] : undefined,
        },
      })}
    >
      {value?.trim() ? (
        <Text color={color} weight={color ? 600 : undefined}>
          {value}
        </Text>
      ) : (
        <Text
          size="sm"
          sx={(theme) => ({
            color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[6],
          })}
        >
          [no answer]
        </Text>
      )}
    </InputWrapper>
  )
}
